import styled from 'styled-components'
import { useQueryBanners } from '@/features/shop/services/Banners/queries'
import { HeaderBanner } from '@/features/shared/components/HeaderBanner'
import { useStoreParams } from '@/features/shared/utils/dataFetching/storeParams'
import { type Banner } from '@/features/shop/services/Banners/types'
import { useCurrentRouteData } from '@/features/shared/hooks/routes/useCurrentRouteData'
import { useUser } from '@/features/account/services/User/hooks'

const handleFocusRef = (node: HTMLDivElement | null) => node?.focus()

export const HeaderBanners = () => {
  const route = useCurrentRouteData()
  return route?.storeRequired ? <RetailerHeaderBanners /> : <GlobalHeaderBanners />
}
const RetailerHeaderBanners = () => {
  const { metro_id, store_id, store_location_id } = useStoreParams()
  const banners =
    useQueryBanners({
      metroId: metro_id ?? 0,
      storeId: store_id ?? 0,
      storeLocationId: store_location_id ?? 0,
    }).data?.banners ?? []

  return <HeaderBannersImpl banners={banners} />
}

const GlobalHeaderBanners = () => {
  const user = useUser()
  const metroId = Number(user?.default_address_metro_id ?? 0)
  const banners = useQueryBanners({ metroId }).data?.banners ?? []

  return <HeaderBannersImpl banners={banners} />
}

const HeaderBannersImpl = ({ banners }: { banners: Banner[] }) => {
  return banners.length > 0 ? (
    <BannersWrapper ref={handleFocusRef} tabIndex={-1}>
      {banners.map((banner) => (
        <HeaderBanner key={banner.text} data={banner} />
      ))}
    </BannersWrapper>
  ) : null
}

const BannersWrapper = styled.div`
  outline: 0;
  z-index: 9999;
  position: relative;
`
